var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 9"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.1875,
    width: 24,
    height: 24,
    rx: 8.22534,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios_new"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_1506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4.97778,
    y: 4.80469,
    width: 14.1006,
    height: 14.1006,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_ios_new_2",
    d: "M14.1587 17.563L9.10372 12.523C9.04372 12.463 9.00122 12.398 8.97622 12.328C8.95122 12.258 8.93872 12.183 8.93872 12.103C8.93872 12.023 8.95122 11.948 8.97622 11.878C9.00122 11.808 9.04372 11.743 9.10372 11.683L14.1587 6.62797C14.2987 6.48797 14.4737 6.41797 14.6837 6.41797C14.8937 6.41797 15.0737 6.49297 15.2237 6.64297C15.3737 6.79297 15.4487 6.96797 15.4487 7.16797C15.4487 7.36797 15.3737 7.54297 15.2237 7.69297L10.8137 12.103L15.2237 16.513C15.3637 16.653 15.4337 16.8255 15.4337 17.0305C15.4337 17.2355 15.3587 17.413 15.2087 17.563C15.0587 17.713 14.8837 17.788 14.6837 17.788C14.4837 17.788 14.3087 17.713 14.1587 17.563Z",
    fill: "#7E8488"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back_button.f2e455ffc6f01c0bde2cddc91a1be047.svg";
export { ForwardRef as ReactComponent };